import { AddressBasedTemplateCreatePage } from "../check-arguments-templates-shared";
import { INTERNATIONAL_CRIMINAL_DATABASE_TEMPLATE_PAGE_CONFIG } from "./config";

export function InternationalCriminalDatabaseTemplateCreatePage() {
  return (
    <AddressBasedTemplateCreatePage
      config={INTERNATIONAL_CRIMINAL_DATABASE_TEMPLATE_PAGE_CONFIG}
    />
  );
}
